module.exports = __webpack_public_path__ + "static/media/anna_teed_s6idukile.bfc1b6cf.svg";